import {v4 as uuid} from 'uuid';

const COOKIE_NAME = 'x-wasp-uuid';

export class CookieHolder {
  static #cookie = ''

  static initialize = () => {
    const cookie = getCookie(COOKIE_NAME);
    if(cookie) {
      this.#cookie = cookie;
    } else {
      this.#cookie = uuid();
      document.cookie = `${COOKIE_NAME}=${this.#cookie}`
    }
  }

  static get uuidCookie() {
    return this.#cookie;
  }

}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}